import ShareableLinkUserForm from './ShareableLinkUserForm.component';

export default ShareableLinkUserForm;
